/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: [2, { "props": false }] */
import Vue from 'vue';
import company from '@/services/company';
import * as types from '../mutations/biller';

const rebuildBillerProfileIndex = (state) => {
  delete state.billerProfileListIndex;
  state.billerProfileListIndex = {};
  state.billerProfileList.forEach((item, index) => {
    state.billerProfileListIndex[`_${item.id}`] = index;
  });
};

const rebuildBillerSlipIndex = (state) => {
  delete state.billerSlipListIndex;
  state.billerSlipListIndex = {};
  state.billerSlipList.forEach((item, index) => {
    state.billerSlipListIndex[`_${item.id}`] = index;
  });
};

const rebuildBillerUserIndex = (state) => {
  delete state.billerUserListIndex;
  state.billerUserListIndex = {};
  state.billerUserList.forEach((item, index) => {
    state.billerUserListIndex[`_${item.id}`] = index;
  });
};

const state = {
  myAdminInfo: null,
  billerInfo: null,
  isGettingBillerMyAdmin: false,
  isGettingBillerCompany: false,
  isUploadingBillerCompanyFile: false,
  isSubmittingBillerCompanyInfo: false,
  // profiles
  isGettingBillerProfile: false,
  billerProfileList: [],
  billerProfileListIndex: {}, // reverse index
  isSubmittingBillerProfileInfo: false,
  currentBillerProfileId: null,
  isUploadingBillerProfileFile: false,
  // slips
  isGettingBillerSlip: false,
  billerSlipList: [],
  billerSlipListTotalItem: 0,
  billerSlipListIndex: {}, // reverse index
  isSubmittingBillerSlipInfo: false,
  currentBillerSlipId: null,
  // biller's users
  isGettingBillerUser: false,
  billerUserList: [],
  billerUserListIndex: {}, // reverse index
  isSubmittingBillerUserInfo: false,
  currentBillerUserId: null,
  // slips
  isPrintingSlip: false,
  isEmailingSlip: false,
  isDeletingSlip: false,
  isImportingSlip: false,
  slipSearchQuery: null,
  slipSearchOption: ['1'],
};

const getters = {
  billerInfo(state) {
    return state.billerInfo;
  },
  myAdminInfo(state) {
    return state.myAdminInfo;
  },
  isInitialLoading(state) {
    return state.isGettingBillerMyAdmin || state.isGettingBillerCompany;
  },
  // PROFILES
  billerProfileList(state) {
    return state.billerProfileList;
  },
  billerProfileListIndex(state) {
    return state.billerProfileListIndex;
  },
  currentBillerProfile(state) {
    if (state.currentBillerProfileId) {
      const indexId = `_${state.currentBillerProfileId}`;
      if (typeof state.billerProfileListIndex[indexId] !== 'undefined') {
        return state.billerProfileList[state.billerProfileListIndex[indexId]];
      }
    }
    return null;
  },
  // SLIPS
  billerSlipList(state) {
    return state.billerSlipList;
  },
  billerSlipListTotalItem(state) {
    return state.billerSlipListTotalItem;
  },
  billerSlipListIndex(state) {
    return state.billerSlipListIndex;
  },
  currentBillerSlip(state) {
    if (state.currentBillerSlipId) {
      const indexId = `_${state.currentBillerSlipId}`;
      if (typeof state.billerSlipListIndex[indexId] !== 'undefined') {
        return state.billerSlipList[state.billerSlipListIndex[indexId]];
      }
    }
    return null;
  },
  // BILLER USERS
  billerUserList(state) {
    return state.billerUserList;
  },
  billerUserListIndex(state) {
    return state.billerUserListIndex;
  },
  currentBillerUser(state) {
    if (state.currentBillerUserId) {
      const indexId = `_${state.currentBillerUserId}`;
      if (typeof state.billerUserListIndex[indexId] !== 'undefined') {
        return state.billerUserList[state.billerUserListIndex[indexId]];
      }
    }
    return null;
  },
  isPrintingSlip(state) {
    return state.isPrintingSlip;
  },
  slipSearchQuery(state) {
    return state.slipSearchQuery;
  },
  slipSearchOption(state) {
    return state.slipSearchOption;
  },
};
const actions = {
  BILLER_CLEAR_STATE({ commit }) {
    return new Promise((resolve) => {
      commit(types.BILLER_STATE_CLEARED);
      resolve();
    });
  },
  GET_BILLER_MY_ADMIN_INFO({ commit }) {
    return new Promise((resolve, reject) => {
      commit(types.GET_BILLER_MY_ADMIN_INFO_REQUEST);
      company.getBillerMyAdmin((err, result) => {
        if (err) {
          commit(types.GET_BILLER_MY_ADMIN_INFO_FAIL);
          return reject(err);
        }
        commit(types.GET_BILLER_MY_ADMIN_INFO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  GET_BILLER_COMPANY_INFO({ commit }, companyId) {
    return new Promise((resolve, reject) => {
      commit(types.GET_BILLER_COMPANY_INFO_REQUEST);
      company.getBillerCompany(companyId, (err, result) => {
        if (err) {
          commit(types.GET_BILLER_COMPANY_INFO_FAIL);
          return reject(err);
        }
        commit(types.GET_BILLER_COMPANY_INFO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  UPLOAD_BILLER_COMPANY_LOGO({ commit }, file) {
    return new Promise((resolve, reject) => {
      commit(types.UPLOAD_BILLER_COMPANY_LOGO_REQUEST);
      company.uploadCompanyLogo(file, (err, result) => {
        if (err) {
          commit(types.UPLOAD_BILLER_COMPANY_LOGO_FAIL);
          return reject(err);
        }
        commit(types.UPLOAD_BILLER_COMPANY_LOGO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  UPDATE_BILLER_COMPANY_INFO({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit(types.UPDATE_BILLER_COMPANY_INFO_REQUEST);
      company.updateCompanyInfo(payload, (err, result) => {
        if (err) {
          commit(types.UPDATE_BILLER_COMPANY_INFO_FAIL);
          return reject(err);
        }
        commit(types.UPDATE_BILLER_COMPANY_INFO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  // Profiles
  GET_BILLER_PROFILE_LIST({ commit }) {
    return new Promise((resolve, reject) => {
      commit(types.GET_BILLER_PROFILE_LIST_REQUEST);
      // company.getCompanyProfile(companyId, (err, result) => {
      company.getBillerCompanyProfile((err, result) => {
        if (err) {
          commit(types.GET_BILLER_PROFILE_LIST_FAIL);
          return reject(err);
        }
        commit(types.GET_BILLER_PROFILE_LIST_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  UPLOAD_BILLER_PROFILE_LOGO({ commit }, file) {
    return new Promise((resolve, reject) => {
      commit(types.UPLOAD_BILLER_PROFILE_LOGO_REQUEST);
      company.uploadCompanyLogo(file, (err, result) => {
        if (err) {
          commit(types.UPLOAD_BILLER_PROFILE_LOGO_FAIL);
          return reject(err);
        }
        commit(types.UPLOAD_BILLER_PROFILE_LOGO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  SELECT_CURRENT_BILLER_PROFILE({ commit }, profileId) {
    return new Promise((resolve) => {
      commit(types.CURRENT_BILLER_PROFILE_SELECTED, profileId);
      resolve();
    });
  },
  UPDATE_BILLER_PROFILE_INFO({ commit }, { profileId, payload }) {
    return new Promise((resolve, reject) => {
      commit(types.UPDATE_BILLER_PROFILE_INFO_REQUEST);
      company.updateCompanyProfile(profileId, payload, (err, result) => {
        if (err) {
          commit(types.UPDATE_BILLER_PROFILE_INFO_FAIL);
          return reject(err);
        }
        commit(types.UPDATE_BILLER_PROFILE_INFO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  DELETE_BILLER_PROFILE_INFO({ commit }, profileId) {
    return new Promise((resolve, reject) => {
      commit(types.DELETE_BILLER_PROFILE_INFO_REQUEST);
      company.deleteCompanyProfile(profileId, (err) => {
        if (err) {
          commit(types.DELETE_BILLER_PROFILE_INFO_FAIL);
          return reject(err);
        }
        commit(types.DELETE_BILLER_PROFILE_INFO_SUCCESS, profileId);
        return resolve();
      });
    });
  },
  // Slips
  GET_BILLER_SLIP_LIST({ commit }, reqPayload) {
    return new Promise((resolve, reject) => {
      commit(types.GET_BILLER_SLIP_LIST_REQUEST, reqPayload.payload);
      company.getBillerSlips(reqPayload, (err, result) => {
        if (err) {
          commit(types.GET_BILLER_SLIP_LIST_FAIL);
          return reject(err);
        }
        commit(types.GET_BILLER_SLIP_LIST_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  SELECT_CURRENT_BILLER_SLIP({ commit }, slipId) {
    return new Promise((resolve) => {
      commit(types.CURRENT_BILLER_SLIP_SELECTED, slipId);
      resolve();
    });
  },
  CREATE_BILLER_SLIP_INFO({ commit }, { profileId, payload }) {
    return new Promise((resolve, reject) => {
      commit(types.CREATE_BILLER_SLIP_INFO_REQUEST);
      company.createBillerSlip(profileId, payload, (err, result) => {
        if (err) {
          commit(types.CREATE_BILLER_SLIP_INFO_FAIL);
          return reject(err);
        }
        commit(types.CREATE_BILLER_SLIP_INFO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  UPDATE_BILLER_SLIP_INFO({ commit }, { slipId, payload }) {
    return new Promise((resolve, reject) => {
      commit(types.UPDATE_BILLER_SLIP_INFO_REQUEST);
      company.updateBillerSlip(slipId, payload, (err, result) => {
        if (err) {
          commit(types.UPDATE_BILLER_SLIP_INFO_FAIL);
          return reject(err);
        }
        commit(types.UPDATE_BILLER_SLIP_INFO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  DELETE_BILLER_SLIP_INFO({ commit }, slipId) {
    return new Promise((resolve, reject) => {
      commit(types.DELETE_BILLER_SLIP_INFO_REQUEST);
      company.deleteBillerSlip(slipId, (err) => {
        if (err) {
          commit(types.DELETE_BILLER_SLIP_INFO_FAIL);
          return reject(err);
        }
        commit(types.DELETE_BILLER_SLIP_INFO_SUCCESS, slipId);
        return resolve();
      });
    });
  },
  IMPORT_BILLER_SLIPS({ commit }, { profileId, payload }) {
    return new Promise((resolve, reject) => {
      commit(types.IMPORT_BILLER_SLIPS_REQUEST);
      company.importBillerSlips(profileId, payload, (err, result) => {
        if (err) {
          commit(types.IMPORT_BILLER_SLIPS_FAIL);
          return reject(err);
        }
        commit(types.IMPORT_BILLER_SLIPS_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  // Biller Users
  GET_BILLER_USER_LIST({ commit }) {
    return new Promise((resolve, reject) => {
      commit(types.GET_BILLER_USER_LIST_REQUEST);
      company.getBillerUsers((err, result) => {
        if (err) {
          commit(types.GET_BILLER_USER_LIST_FAIL);
          return reject(err);
        }
        commit(types.GET_BILLER_USER_LIST_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  SELECT_CURRENT_BILLER_USER({ commit }, userId) {
    return new Promise((resolve) => {
      commit(types.CURRENT_BILLER_USER_SELECTED, userId);
      resolve();
    });
  },
  CREATE_BILLER_USER_INFO({ commit }, { companyId, payload }) {
    return new Promise((resolve, reject) => {
      commit(types.CREATE_BILLER_USER_INFO_REQUEST);
      company.createBillerUser(companyId, payload, (err, result) => {
        if (err) {
          commit(types.CREATE_BILLER_USER_INFO_FAIL);
          return reject(err);
        }
        commit(types.CREATE_BILLER_USER_INFO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  UPDATE_BILLER_USER_INFO({ commit }, { userId, payload }) {
    return new Promise((resolve, reject) => {
      commit(types.UPDATE_BILLER_USER_INFO_REQUEST);
      company.updateBillerUser(userId, payload, (err, result) => {
        if (err) {
          commit(types.UPDATE_BILLER_USER_INFO_FAIL);
          return reject(err);
        }
        commit(types.UPDATE_BILLER_USER_INFO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  DELETE_BILLER_USER_INFO({ commit }, userId) {
    return new Promise((resolve, reject) => {
      commit(types.DELETE_BILLER_USER_INFO_REQUEST);
      company.deleteCompanyAdmin(userId, (err) => {
        if (err) {
          commit(types.DELETE_BILLER_USER_INFO_FAIL);
          return reject(err);
        }
        commit(types.DELETE_BILLER_USER_INFO_SUCCESS, userId);
        return resolve();
      });
    });
  },
  UNBLOCK_BILLER_USER({ commit }, userId) {
    return new Promise((resolve, reject) => {
      commit(types.UNBLOCK_BILLER_USER_REQUEST);
      company.unblockBillerAdmin(userId, (err) => {
        if (err) {
          commit(types.UNBLOCK_BILLER_USER_FAIL);
          return reject(err);
        }
        commit(types.UNBLOCK_BILLER_USER_SUCCESS, userId);
        return resolve();
      });
    });
  },
  PRINT_PAYER_SLIP({ commit }, { profileId, slips }) {
    return new Promise((resolve, reject) => {
      commit(types.PRINT_PAYER_SLIPS_REQUEST);
      company.printPayerSlips(profileId, slips, (err, result) => {
        if (err) {
          commit(types.PRINT_PAYER_SLIPS_FAIL);
          return reject(err);
        }
        commit(types.PRINT_PAYER_SLIPS_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  PRINT_PAYER_QR({ commit }, { profileId, slips }) {
    return new Promise((resolve, reject) => {
      commit(types.PRINT_PAYER_SLIPS_REQUEST);
      company.printPayerQR(profileId, slips, (err, result) => {
        if (err) {
          commit(types.PRINT_PAYER_SLIPS_FAIL);
          return reject(err);
        }
        commit(types.PRINT_PAYER_SLIPS_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  EMAIL_PAYER_SLIP({ commit }, { profileId, slips }) {
    return new Promise((resolve, reject) => {
      commit(types.EMAIL_PAYER_SLIPS_REQUEST);
      company.emailPayerSlips(profileId, slips, (err, result) => {
        if (err) {
          commit(types.EMAIL_PAYER_SLIPS_FAIL);
          return reject(err);
        }
        commit(types.EMAIL_PAYER_SLIPS_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  EMAIL_PAYER_QR({ commit }, { profileId, slips }) {
    return new Promise((resolve, reject) => {
      commit(types.EMAIL_PAYER_SLIPS_REQUEST);
      company.emailPayerQR(profileId, slips, (err, result) => {
        if (err) {
          commit(types.EMAIL_PAYER_SLIPS_FAIL);
          return reject(err);
        }
        commit(types.EMAIL_PAYER_SLIPS_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  DELETE_PAYER_SLIP({ commit }, { profileId, slips }) {
    return new Promise((resolve, reject) => {
      commit(types.DELETE_PAYER_SLIPS_REQUEST);
      company.deletePayerSlips(profileId, slips, (err, result) => {
        if (err) {
          commit(types.DELETE_PAYER_SLIPS_FAIL);
          return reject(err);
        }
        commit(types.DELETE_PAYER_SLIPS_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  TOGGLE_BILLER_SLIP_SEARCH_OPTION({ commit }) {
    commit(types.TOGGLE_BILLER_SLIP_SEARCH_OPTION);
  },
  UPLOAD_BILLER_OTHER_BANK_LOGO({ commit }, file) {
    return new Promise((resolve, reject) => {
      commit(types.UPLOAD_BILLER_OTHER_BANK_LOGO_REQUEST);
      company.uploadOtherBankLogo(file, (err, result) => {
        if (err) {
          commit(types.UPLOAD_BILLER_OTHER_BANK_LOGO_FAIL);
          return reject(err);
        }
        commit(types.UPLOAD_BILLER_OTHER_BANK_LOGO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
};

const mutations = {
  [types.GET_BILLER_MY_ADMIN_INFO_REQUEST](state) {
    state.isGettingBillerMyAdmin = true;
  },
  [types.GET_BILLER_MY_ADMIN_INFO_SUCCESS](state, result) {
    state.isGettingBillerMyAdmin = false;
    state.myAdminInfo = result;
  },
  [types.GET_BILLER_MY_ADMIN_INFO_FAIL](state) {
    state.isGettingBillerMyAdmin = false;
  },
  [types.GET_BILLER_COMPANY_INFO_REQUEST](state) {
    state.isGettingBillerCompany = true;
  },
  [types.GET_BILLER_COMPANY_INFO_SUCCESS](state, result) {
    state.isGettingBillerCompany = false;
    state.billerInfo = result;
  },
  [types.GET_BILLER_COMPANY_INFO_FAIL](state) {
    state.isGettingBillerCompany = false;
  },
  [types.UPLOAD_BILLER_COMPANY_LOGO_REQUEST](state) {
    state.isUploadingBillerCompanyFile = true;
  },
  [types.UPLOAD_BILLER_COMPANY_LOGO_FAIL](state) {
    state.isUploadingBillerCompanyFile = false;
  },
  [types.UPLOAD_BILLER_COMPANY_LOGO_SUCCESS](state) {
    state.isUploadingBillerCompanyFile = false;
  },
  [types.UPDATE_BILLER_COMPANY_INFO_REQUEST](state) {
    state.isSubmittingBillerCompanyInfo = true;
  },
  [types.UPDATE_BILLER_COMPANY_INFO_FAIL](state) {
    state.isSubmittingBillerCompanyInfo = false;
  },
  [types.UPDATE_BILLER_COMPANY_INFO_SUCCESS](state, result) {
    state.isSubmittingBillerCompanyInfo = false;
    // replace data
    state.billerInfo = result;
  },
  // PROFILES
  [types.GET_BILLER_PROFILE_LIST_REQUEST](state) {
    state.isGettingBillerProfile = true;
  },
  [types.GET_BILLER_PROFILE_LIST_SUCCESS](state, result) {
    state.isGettingBillerProfile = false;
    state.billerProfileList = result;
    // rebuild index
    rebuildBillerProfileIndex(state);
  },
  [types.GET_BILLER_PROFILE_LIST_FAIL](state) {
    state.isGettingBillerProfile = false;
  },
  [types.CURRENT_BILLER_PROFILE_SELECTED](state, profileId) {
    state.currentBillerProfileId = profileId;
  },
  [types.UPLOAD_BILLER_PROFILE_LOGO_REQUEST](state) {
    state.isUploadingBillerProfileFile = true;
  },
  [types.UPLOAD_BILLER_PROFILE_LOGO_FAIL](state) {
    state.isUploadingBillerProfileFile = false;
  },
  [types.UPLOAD_BILLER_PROFILE_LOGO_SUCCESS](state) {
    state.isUploadingBillerProfileFile = false;
  },
  [types.UPDATE_BILLER_PROFILE_INFO_REQUEST](state) {
    state.isSubmittingBillerProfileInfo = true;
  },
  [types.UPDATE_BILLER_PROFILE_INFO_FAIL](state) {
    state.isSubmittingBillerProfileInfo = false;
  },
  [types.UPDATE_BILLER_PROFILE_INFO_SUCCESS](state, result) {
    state.isSubmittingBillerProfileInfo = false;
    // replace data in companyList
    const profileId = `_${result.id}`;
    if (typeof state.billerProfileListIndex[profileId] !== 'undefined') {
      state.billerProfileList.splice(state.billerProfileListIndex[profileId], 1, result);
    }
  },
  [types.DELETE_BILLER_PROFILE_INFO_REQUEST](state) {
    state.isSubmittingBillerProfileInfo = true;
  },
  [types.DELETE_BILLER_PROFILE_INFO_FAIL](state) {
    state.isSubmittingBillerProfileInfo = false;
  },
  [types.DELETE_BILLER_PROFILE_INFO_SUCCESS](state, profileId) {
    state.currentBillerProfileId = null;
    state.isSubmittingBillerProfileInfo = false;
    // remove data in companyList
    const idx = `_${profileId}`;
    if (typeof state.billerProfileListIndex[idx] !== 'undefined') {
      // delete state.billerProfileList[state.billerProfileListIndex[idx]];
      state.billerProfileList.splice(state.billerProfileListIndex[idx], 1);
      rebuildBillerProfileIndex(state);
    }
  },
  // SLIPS
  [types.GET_BILLER_SLIP_LIST_REQUEST](state, query) {
    state.isGettingBillerSlip = true;
    state.slipSearchQuery = {};
    Object.keys(query).forEach((key) => {
      if (key !== 'offset') {
        Vue.set(state.slipSearchQuery, key, query[key]);
      } else {
        Vue.set(state.slipSearchQuery, key, 0);
      }
    });
  },
  [types.GET_BILLER_SLIP_LIST_SUCCESS](state, { total, data }) {
    state.isGettingBillerSlip = false;
    state.billerSlipList = data;
    state.billerSlipListTotalItem = total;
    // rebuild index
    rebuildBillerSlipIndex(state);
  },
  [types.GET_BILLER_SLIP_LIST_FAIL](state) {
    state.isGettingBillerSlip = false;
  },
  [types.CURRENT_BILLER_SLIP_SELECTED](state, profileId) {
    state.currentBillerSlipId = profileId;
  },
  [types.CREATE_BILLER_SLIP_INFO_REQUEST](state) {
    state.isSubmittingBillerSlipInfo = true;
  },
  [types.CREATE_BILLER_SLIP_INFO_FAIL](state) {
    state.isSubmittingBillerSlipInfo = false;
  },
  [types.CREATE_BILLER_SLIP_INFO_SUCCESS](state, result) {
    state.isSubmittingBillerSlipInfo = false;
    // add data in slipList
    state.billerSlipList.push(result);
    rebuildBillerSlipIndex(state);
  },
  [types.UPDATE_BILLER_SLIP_INFO_REQUEST](state) {
    state.isSubmittingBillerSlipInfo = true;
  },
  [types.UPDATE_BILLER_SLIP_INFO_FAIL](state) {
    state.isSubmittingBillerSlipInfo = false;
  },
  [types.UPDATE_BILLER_SLIP_INFO_SUCCESS](state, result) {
    state.isSubmittingBillerSlipInfo = false;
    // replace data in companyList
    const slipId = `_${result.id}`;
    if (typeof state.billerSlipListIndex[slipId] !== 'undefined') {
      state.billerSlipList.splice(state.billerSlipListIndex[slipId], 1, result);
    }
  },
  [types.DELETE_BILLER_SLIP_INFO_REQUEST](state) {
    state.isSubmittingBillerSlipInfo = true;
  },
  [types.DELETE_BILLER_SLIP_INFO_FAIL](state) {
    state.isSubmittingBillerSlipInfo = false;
  },
  [types.DELETE_BILLER_SLIP_INFO_SUCCESS](state, slipId) {
    state.currentBillerProfileId = null;
    state.isSubmittingBillerSlipInfo = false;
    // remove data in companyList
    const idx = `_${slipId}`;
    if (typeof state.billerSlipListIndex[idx] !== 'undefined') {
      state.billerSlipList.splice(state.billerSlipListIndex[idx], 1);
      rebuildBillerSlipIndex(state);
    }
  },
  // BILLER USERS
  [types.GET_BILLER_USER_LIST_REQUEST](state) {
    state.isGettingBillerUser = true;
  },
  [types.GET_BILLER_USER_LIST_SUCCESS](state, result) {
    state.isGettingBillerUser = false;
    state.billerUserList = result;
    // rebuild index
    rebuildBillerUserIndex(state);
  },
  [types.GET_BILLER_USER_LIST_FAIL](state) {
    state.isGettingBillerUser = false;
  },
  [types.CURRENT_BILLER_USER_SELECTED](state, userId) {
    state.currentBillerUserId = userId;
  },
  [types.CREATE_BILLER_USER_INFO_REQUEST](state) {
    state.isSubmittingBillerUserInfo = true;
  },
  [types.CREATE_BILLER_USER_INFO_FAIL](state) {
    state.isSubmittingBillerUserInfo = false;
  },
  [types.CREATE_BILLER_USER_INFO_SUCCESS](state, result) {
    state.isSubmittingBillerUserInfo = false;
    // inject data to billerUserList
    state.billerUserList.push(result);
    rebuildBillerUserIndex(state);
  },
  [types.UPDATE_BILLER_USER_INFO_REQUEST](state) {
    state.isSubmittingBillerUserInfo = true;
  },
  [types.UPDATE_BILLER_USER_INFO_FAIL](state) {
    state.isSubmittingBillerUserInfo = false;
  },
  [types.UPDATE_BILLER_USER_INFO_SUCCESS](state, result) {
    state.isSubmittingBillerUserInfo = false;
    // replace data in billerUserList
    const userId = `_${result.id}`;
    if (typeof state.billerUserListIndex[userId] !== 'undefined') {
      state.billerUserList.splice(state.billerUserListIndex[userId], 1, result);
    }
  },
  [types.DELETE_BILLER_USER_INFO_REQUEST](state) {
    state.isSubmittingBillerUserInfo = true;
  },
  [types.DELETE_BILLER_USER_INFO_FAIL](state) {
    state.isSubmittingBillerUserInfo = false;
  },
  [types.DELETE_BILLER_USER_INFO_SUCCESS](state, userId) {
    state.currentBillerUserId = null;
    state.isSubmittingBillerUserInfo = false;
    // remove data in companyList
    const idx = `_${userId}`;
    if (typeof state.billerUserListIndex[idx] !== 'undefined') {
      // delete state.billerUserList[state.billerProfileListIndex[idx]];
      state.billerUserList.splice(state.billerProfileListIndex[idx], 1);
      rebuildBillerUserIndex(state);
    }
  },
  [types.PRINT_PAYER_SLIPS_REQUEST](state) {
    state.isPrintingSlip = true;
  },
  [types.PRINT_PAYER_SLIPS_SUCCESS](state) {
    state.isPrintingSlip = false;
  },
  [types.PRINT_PAYER_SLIPS_FAIL](state) {
    state.isPrintingSlip = false;
  },
  [types.EMAIL_PAYER_SLIPS_REQUEST](state) {
    state.isEmailingSlip = true;
  },
  [types.EMAIL_PAYER_SLIPS_SUCCESS](state) {
    state.isEmailingSlip = false;
  },
  [types.EMAIL_PAYER_SLIPS_FAIL](state) {
    state.isEmailingSlip = false;
  },
  [types.DELETE_PAYER_SLIPS_REQUEST](state) {
    state.isDeletingSlip = true;
  },
  [types.DELETE_PAYER_SLIPS_SUCCESS](state) {
    state.isDeletingSlip = false;
  },
  [types.DELETE_PAYER_SLIPS_FAIL](state) {
    state.isDeletingSlip = false;
  },
  [types.IMPORT_BILLER_SLIPS_REQUEST](state) {
    state.isImportingSlip = true;
  },
  [types.IMPORT_BILLER_SLIPS_SUCCESS](state) {
    state.isImportingSlip = false;
  },
  [types.IMPORT_BILLER_SLIPS_FAIL](state) {
    state.isImportingSlip = false;
  },
  [types.TOGGLE_BILLER_SLIP_SEARCH_OPTION](state) {
    if (state.slipSearchOption.length > 0) {
      state.slipSearchOption.splice(0);
    } else {
      state.slipSearchOption.push('1');
    }
  },
  [types.UPLOAD_BILLER_OTHER_BANK_LOGO_REQUEST](state) {
    state.isUploadingBillerProfileFile = true;
  },
  [types.UPLOAD_BILLER_OTHER_BANK_LOGO_FAIL](state) {
    state.isUploadingBillerProfileFile = false;
  },
  [types.UPLOAD_BILLER_OTHER_BANK_LOGO_SUCCESS](state) {
    state.isUploadingBillerProfileFile = false;
  },
  [types.BILLER_STATE_CLEARED](state) {
    state.myAdminInfo = null;
    state.billerInfo = null;
    state.isGettingBillerMyAdmin = false;
    state.isGettingBillerCompany = false;
    state.isUploadingBillerCompanyFile = false;
    state.isSubmittingBillerCompanyInfo = false;
    state.isGettingBillerProfile = false;
    state.billerProfileList.splice(0);
    state.billerProfileListIndex = {};
    state.isSubmittingBillerProfileInfo = false;
    state.currentBillerProfileId = null;
    state.isUploadingBillerProfileFile = false;
    state.isGettingBillerSlip = false;
    state.billerSlipList.splice(0);
    state.billerSlipListTotalItem = 0;
    state.billerSlipListIndex = {};
    state.isSubmittingBillerSlipInfo = false;
    state.currentBillerSlipId = null;
    state.isGettingBillerUser = false;
    state.billerUserList.splice(0);
    state.billerUserListIndex = {};
    state.isSubmittingBillerUserInfo = false;
    state.currentBillerUserId = null;
    state.isPrintingSlip = false;
    state.isEmailingSlip = false;
    state.isDeletingSlip = false;
    state.slipSearchQuery = null;
    state.slipSearchOption.splice(0);
    state.slipSearchOption.push('1');
  },
};

const BillerStore = {
  state,
  getters,
  actions,
  mutations,
};

export default BillerStore;



// WEBPACK FOOTER //
// ./src/store/modules/biller.js